export enum DocumentType {
  GOVERNMENT_ISSUED_DOCUMENT = 1,
  PROOF_OF_ADDRESS = 2,
}

export enum BusinessTypes {
  FREELANCER = 1,
  REGISTERED_BUSINESS = 2,
  NGO = 3,
  PARTNERSHIP = 4,
  LIMITED_LIABILITY = 5,
}

export enum CustomerPeopleTypes {
  SHAREHOLDER = 1,
  PARTNER = 2,
  OWNER = 3,
  DIRECTOR = 4,
  SENIOR_MANAGEMENT = 5,
  REGISTERED_TRUSTEE = 6,
}
